"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateInsurerDto = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const swagger_1 = require("@nestjs/swagger");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const response_utils_1 = require("../../../../../../../libs/service-lib/src/lib/utils/response.utils");
const create_address_dto_1 = require("../../address/dto/create-address.dto");
class CreateInsurerDto {
}
exports.CreateInsurerDto = CreateInsurerDto;
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: "Insurer Name is required." }),
    (0, class_validator_1.IsString)({ message: "Insurer Name must be a string." }),
    (0, class_validator_1.MaxLength)(200, { message: "Insurer Name must not exceed 200 characters." }),
    (0, class_transformer_1.Transform)(({ value }) => (value ? value.trim() : value)),
    tslib_1.__metadata("design:type", String)
], CreateInsurerDto.prototype, "insurerName", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: "Display Name is required." }),
    (0, class_validator_1.IsString)({ message: "Display Name must be a string." }),
    (0, class_validator_1.MaxLength)(100, { message: "Display Name must not exceed 100 characters." }),
    (0, class_transformer_1.Transform)(({ value }) => (value ? value.trim() : value)),
    tslib_1.__metadata("design:type", String)
], CreateInsurerDto.prototype, "displayName", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: "Company Type ID is required." }),
    (0, class_validator_1.IsInt)({ message: "Company Type ID must be an integer." }),
    tslib_1.__metadata("design:type", Number)
], CreateInsurerDto.prototype, "companyTypeLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => {
        value = value ? value.trim() : value;
        return value?.length === 0 ? null : value;
    }),
    (0, class_validator_1.IsUrl)({}, { message: "Website must be a valid URL." }),
    (0, class_validator_1.MaxLength)(255, { message: "Website must not exceed 255 characters." }),
    tslib_1.__metadata("design:type", String)
], CreateInsurerDto.prototype, "website", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: "Business Type (Is Life ID) is required." }),
    (0, class_validator_1.IsInt)({ message: "Business Type (Is Life ID) must be a integer" }),
    tslib_1.__metadata("design:type", Number)
], CreateInsurerDto.prototype, "isLifeLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsNotEmpty)({ message: "Company Tag ID is required." }),
    (0, class_validator_1.IsInt)({ message: "Company Tag ID must be an integer." }),
    tslib_1.__metadata("design:type", Number)
], CreateInsurerDto.prototype, "companyTagLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => {
        value = value ? value.trim() : value;
        return value?.length === 0 ? null : value;
    }),
    (0, class_validator_1.IsString)({ message: "Insure Code must be a string." }),
    (0, class_validator_1.MaxLength)(100, { message: "Insure Code must not exceed 100 characters." }),
    tslib_1.__metadata("design:type", String)
], CreateInsurerDto.prototype, "insureCode", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Status ID must be an integer." }),
    tslib_1.__metadata("design:type", Number)
], CreateInsurerDto.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Remarks must be a string." }),
    (0, class_transformer_1.Transform)(({ value }) => {
        const cleanedValue = value ? (0, response_utils_1.removeHtmlTags)(value) : value;
        if (cleanedValue && cleanedValue.length > 500) {
            throw new common_1.BadRequestException("Insurer remarks must not exceed 500 characters ");
        }
        return value?.length === 0 ? null : value;
    }),
    tslib_1.__metadata("design:type", String)
], CreateInsurerDto.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateInsurerDto.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateInsurerDto.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], CreateInsurerDto.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], CreateInsurerDto.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "List of addresses associated with the insurer",
        type: [create_address_dto_1.CreateAddressDto],
        required: false,
    }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => create_address_dto_1.CreateAddressDto),
    tslib_1.__metadata("design:type", Array)
], CreateInsurerDto.prototype, "address", void 0);
